export default  [
  {
    category: 'Inicio',
    icon: 'home',
    expand: true,
    pages: [
      { name: 'Comprobantes', path: '/admin/comprobantes', roles: ['02','01','04'], icon: 'chevron-double-right' },
      { name: 'Guías', path: '/admin/guiaRemision', roles: ['02','01','03'], icon: 'clipboard-text', onlyCertifakt: true },
      { name: 'Cotizaciones', path: '/admin/cotizaciones', roles: ['02','01','05'], icon: 'currency-usd'},
      { name: 'Otros', path: '/admin/otros-comprobantes', roles: ['02','01'], icon: 'file-multiple', onlyCertifakt: true },
      { name: 'Lista de Excels', path: '/admin/solicitudes-excel', roles: ['02','01'], icon: 'file-multiple', onlyCertifakt: true }
    ],
    roles: ['02','01','03','04','05']
  },
  {
    category: 'Emisión',
    icon: 'cards-variant',
    expand: false,
    pages: [
      { name: 'Cotización', path: '/admin/cotizaciones/emitir-cotizacion', roles: ['02','01','05'], icon: 'playlist-plus' },
      { name: 'Factura', path: '/admin/comprobantes/emitir-factura', roles: ['02','01'], icon: 'playlist-plus' },
      { name: 'Boleta', path: '/admin/comprobantes/emitir-boleta', roles: ['02','01'], icon: 'playlist-plus' },
      { name: 'Nota de crédito', path: '/admin/comprobantes/emitir-nota-credito', roles: ['02','01'], icon: 'playlist-plus', onlyCertifakt: true },
      { name: 'Nota de débito', path: '/admin/comprobantes/emitir-nota-debito', roles: ['02','01'], icon: 'playlist-plus', onlyCertifakt: true },
      { name: 'Emision masiva', path: '/admin/comprobantes/emision-masiva', roles: ['02','01'], icon: 'playlist-plus', onlyCertifakt: true},
      { name: 'Guía de Remisión', path: '/admin/guiaRemision/guia-remitente', roles: ['02', '01', '03'], icon: 'playlist-plus', onlyCertifakt: true },
      { name: 'Guía Transportista', path: '/admin/guiaRemision/guia-transportista', roles: ['02','01','03'], icon: 'playlist-plus', onlyCertifakt: true },
      { name: 'Retenciones', path: '/admin/otros-comprobantes/retencion', roles: ['02','01'], icon: 'playlist-plus', onlyCertifakt: true },
      { name: 'Percepciones', path: '/admin/otros-comprobantes/percepcion', roles: ['02','01'], icon: 'playlist-plus', onlyCertifakt: true }
    ],
    roles: ['02','01','03','05']
  },
  {
    category: 'Graficos',
    icon: 'chart-areaspline',
    expand: false,
    pages: [
      { name: 'Ventas', path: '/admin/grafica-venta', roles: ['01'], icon: 'receipt' },
      { name: 'Cotizaciones', path: '/admin/grafica-coti', roles: ['01'], icon: 'calculator' },
      { name: 'Compras', path: '/admin/grafica-compras', roles: ['01'], icon: 'cart' }
    ],
    roles: ['02','01']
  },
  {
    category: 'Registro',
    icon: 'buffer',
    expand: false,
    pages: [
      { name: 'Productos', path: '/admin/productos', roles: ['01'], icon: 'barcode-scan' },
      { name: 'Clientes', path: '/admin/clientes', roles: ['01'], icon: 'camera-front-variant' },
      { name: 'Direcciones', path: '/admin/direcciones', roles: ['01'], icon: 'camera-front-variant' },
      { name: 'Unidades', path: '/admin/unidades', roles: ['01'], icon: 'camera-front-variant' },
      { name: 'Compras', path: '/admin/compras', roles: ['01'], icon: 'camera-front-variant' },
      { name: 'Proveedores', path: '/admin/proveedores', roles: ['01'], icon: 'camera-front-variant' },
    ],
    roles: ['01']
  },
  {
    category: 'Administración',
    icon: 'dns',
    expand: false,
    pages: [
      { name: 'Usuarios', path: '/admin/usuarios', roles: ['01'], icon: 'account' }
    ],
    roles: ['01','02']
  }
]



// WEBPACK FOOTER //
// ./src/menu.js